<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitle }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button" @click="$router.go(-1)">
              {{$t('addSchemaComptable.actions.cancel')}}
            </a>
            <a class="button is-addOrEdit"
               @click="addOrUpdateSchemaComptable()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :error="error"
                         :title="'addSchemaComptable.error.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p> {{ $t('addSchemaComptable.informationSchemaComptable.title') }} </p>
        </header>
        <div class="card-content">
          <div class="columns">
            <div class="column is-6">
              <b-field
                :label="$t('addSchemaComptable.informationSchemaComptable.libelle')"
                class="obligatoire">
                <b-input v-model="schemaComptable.libelle"></b-input>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field
                :label="$t('addSchemaComptable.informationSchemaComptable.type')"
                class="obligatoire">
                <b-select v-model="schemaComptable.type" expanded>
                  <option v-for="value in listeTypeSchemaComptable"
                          :value="value.code" :key="value.code">
                    {{ $t(value.libelle) }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p> {{ $t('addSchemaComptable.informationCompteComptable.title') }} </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-3">
              <b-field
                :label="$t('addSchemaComptable.informationCompteComptable.compteNormal')">
                <b-tooltip class="width-100percent"
                  :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip'
                  )">
                  <b-input v-model="schemaComptable.compteNormal"></b-input>
                </b-tooltip>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field
                :label=
                  "$t('addSchemaComptable.informationCompteComptable.compteIntracommunautaire')">
                <b-input v-model="schemaComptable.compteIntracommunautaire"></b-input>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field
                :label="$t('addSchemaComptable.informationCompteComptable.compteExport')">
                <b-tooltip class="width-100percent"
                  :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip'
                  )">
                  <b-input v-model="schemaComptable.compteExport"></b-input>
                </b-tooltip>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field
                :label="$t('addSchemaComptable.informationCompteComptable.produitConstate')">
                <b-input v-model="schemaComptable.compteConstateDavance"></b-input>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field
                :label="$t('addSchemaComptable.informationCompteComptable.compteTvaDebit')">
                <b-tooltip class="width-100percent"
                  :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip')
                  ">
                  <b-input v-model="schemaComptable.compteTva"></b-input>
                </b-tooltip>
              </b-field>
            </div>
            <div class="column is-1">
              <b-field
                :label="$t('addSchemaComptable.informationCompteComptable.tvaSurEncaissement')">
                <qd-switch class="mgt-8px" v-model="schemaComptable.tvaSurEncaissement"></qd-switch>
              </b-field>
            </div>
            <div class="column is-2">
              <b-field
                :label="$t('addSchemaComptable.informationCompteComptable.compteTvaEncaissement')">
                <b-input v-model="schemaComptable.compteTvaEncaissement"></b-input>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field
                :label="
                $t(
              'addSchemaComptable.informationCompteComptable.compteTvaDeductibleIntracommunautaire'
                )">
                <b-input v-model="schemaComptable.compteTvaDeductibleIntracommunautaire"></b-input>
              </b-field>
            </div>
            <div class="column is-3" v-if="priseEnCompteRemiseCompta">
              <b-field
                :label="$t('addSchemaComptable.informationCompteComptable.compteRemiseHorsRegie')">
                <b-input v-model="schemaComptable.compteRemiseGeneral"></b-input>
              </b-field>
            </div>
            <div class="column is-3" v-if="priseEnCompteRemiseCompta">
              <b-field
                :label="$t('addSchemaComptable.informationCompteComptable.compteRemiseRegie')">
                <b-input v-model="schemaComptable.compteRemiseRegie"></b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p> {{ $t('addSchemaComptable.parametrageLibelle.title') }} </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-12">
              <b-field
                :label="$t('addSchemaComptable.parametrageLibelle.ecriture')">
                <b-input v-model="schemaComptable.libelleEcriture"
                         @click.native="editLibelle('ecriture', schemaComptable.libelleEcriture)"/>
              </b-field>
            </div>
            <div class="column is-12">
              <b-field
                :label="$t('addSchemaComptable.parametrageLibelle.ecritureTiers')">
                <b-input v-model="schemaComptable.libelleLigneEcritureTiers"
                         @click.native="editLibelle('ecritureTiers',
                         schemaComptable.libelleLigneEcritureTiers)"/>
              </b-field>
            </div>
            <div class="column is-12">
              <b-field
                :label="$t('addSchemaComptable.parametrageLibelle.ecritureTva')">
                <b-input v-model="schemaComptable.libelleLigneEcritureTva"
                         @click.native="editLibelle('ecritureTva',
                         schemaComptable.libelleLigneEcritureTva)"/>
              </b-field>
            </div>
            <div class="column is-12">
              <b-field
                :label="$t('addSchemaComptable.parametrageLibelle.ecritureContrepartie')">
                <b-input v-model="schemaComptable.libelleLigneEcritureContrepartie"
                         @click.native="editLibelle('ecritureContrepartie',
                         schemaComptable.libelleLigneEcritureContrepartie)"/>
              </b-field>
            </div>
            <div class="column is-12" v-if="schemaComptable.type === constantes.ACHAT">
              <b-field
                :label="$t('addSchemaComptable.parametrageLibelle.referenceTiers')">
                <b-input v-model="schemaComptable.referenceLigneEcritureTiers"
                         @click.native="editReference('referenceTiers',
                         schemaComptable.referenceLigneEcritureTiers)"/>
              </b-field>
            </div>
            <div class="column is-12" v-if="schemaComptable.type === constantes.ACHAT">
              <b-field
                :label="$t('addSchemaComptable.parametrageLibelle.referenceContrepartie')">
                <b-input v-model="schemaComptable.referenceLigneEcritureContrepartie"
                         @click.native="editReference('referenceContrepartie',
                         schemaComptable.referenceLigneEcritureContrepartie)"/>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showEditLibelle" has-modal-card class="modal">
      <editLibelle :value="valueLibelleTmp"
                   :type="typeEditLibelle"
                   @close="closeEdit()"
                   @save="getValueLibelle($event)"/>
    </b-modal>
    <b-modal v-model="showEditReference" has-modal-card class="modal">
      <editReference :value="valueReferenceTmp"
                   :type="typeEditReference"
                   @close="closeEdit()"
                   @save="getValueReference($event)"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererSchemaComptable from '@/services/parametrage/generation/genererSchemaComptable';
import breadcrumb from '@/components/general/breadcrumb';
import { create, get, update } from '@/api/schemaComptable/index';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import { LISTE_TYPE_SCHEMA_COMPTABLE, ACHAT } from '@/configuration/parametrage/schemaComptableConf';
import editLibelle from '@/components/parametrage/schemaComptable/p_editLibelleEcriture';
import editReference from '@/components/parametrage/schemaComptable/p_editReferenceEcriture';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/compta/schemaComptable/translator';

const Parametres = createNamespacedHelpers('parametres');
export default {
  data() {
    return {
      schemaComptable: genererSchemaComptable(),
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      listeTypeSchemaComptable: LISTE_TYPE_SCHEMA_COMPTABLE,
      showEditLibelle: false,
      valueLibelleTmp: '',
      typeEditLibelle: '',
      libelle: '',
      showEditReference: false,
      valueReferenceTmp: '',
      typeEditReference: '',
      constantes: {
        ACHAT,
      },
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    editLibelle,
    errorMsgComponent,
    editReference,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async addOrUpdateSchemaComptable() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        let schemaComptable = null;
        if (!this.$route.params.id) {
          schemaComptable = (await create(this.schemaComptable)).data.result;
          messageSucces(this.$t('addSchemaComptable.success.add'));
        } else {
          schemaComptable = (await update(this.schemaComptable)).data.result;
          messageSucces(this.$t('addSchemaComptable.success.edit'));
        }
        loadingComponent.close();
        await this.$router.push({ name: 'c.parametrage.schema_comptable', params: { id: schemaComptable.id } });
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    editLibelle(type, value) {
      this.typeEditLibelle = type;
      this.valueLibelleTmp = value;
      this.showEditLibelle = true;
    },
    editReference(type, value) {
      this.typeEditReference = type;
      this.valueReferenceTmp = value;
      this.showEditReference = true;
    },
    closeEdit() {
      this.showEditLibelle = false;
      this.typeEditLibelle = '';
      this.valueLibelleTmp = '';
      this.typeEditReference = '';
      this.valueReferenceTmp = '';
      this.showEditReference = false;
    },
    getValueLibelle(libelle) {
      if (libelle.type === 'ecriture') {
        this.schemaComptable.libelleEcriture = libelle.value;
      }
      if (libelle.type === 'ecritureTiers') {
        this.schemaComptable.libelleLigneEcritureTiers = libelle.value;
      }
      if (libelle.type === 'ecritureTva') {
        this.schemaComptable.libelleLigneEcritureTva = libelle.value;
      }
      if (libelle.type === 'ecritureContrepartie') {
        this.schemaComptable.libelleLigneEcritureContrepartie = libelle.value;
      }
      this.typeEditLibelle = '';
      this.valueLibelleTmp = '';
    },
    getValueReference(reference) {
      switch (reference.type) {
        case 'referenceTiers':
          this.schemaComptable.referenceLigneEcritureTiers = reference.value;
          break;
        case 'referenceContrepartie':
          this.schemaComptable.referenceLigneEcritureContrepartie = reference.value;
          break;
        default: break;
      }
      this.typeEditReference = '';
      this.valueReferenceTmp = '';
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    breadcrumb() {
      const output = [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeSchemaComptable.title'), route: { name: 'l.parametrage.schema_comptable' }, isActive: false },
        { title: this.getTitle, route: { name: '' }, isActive: true },
      ];
      return output;
    },
    getTitle() {
      if (this.$route.params.id) return this.$t('addSchemaComptable.titleEdit', { libelle: this.libelle });
      return this.$t('addSchemaComptable.titleAdd');
    },
    priseEnCompteRemiseCompta() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.remiseComptabilisee.key);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.remiseComptabilisee.key]);
      if (this.$route.params.id) {
        this.schemaComptable = (await get(this.$route.params.id)).data.result;
        this.libelle = cloneDeep(this.schemaComptable.libelle);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.schemaComptable.libelle }));
      } else this.setInformationPage(this.$t('pageParametrage.schemaComptable.creation'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
